import { render, staticRenderFns } from "./trading-phase-icon.component.vue?vue&type=template&id=12febc2b"
import script from "./trading-phase-icon.component.vue?vue&type=script&lang=js"
export * from "./trading-phase-icon.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports